var _defs, _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack5Solid40({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "7.78 0.75 0.28 15.24 15.28 15.24 7.78 0.75"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.69,11.94V10.3a2.25,2.25,0,0,1-1.13-.66,1.67,1.67,0,0,1-.35-1.08,1.52,1.52,0,0,1,.4-1.08A1.66,1.66,0,0,1,7.69,7V6.6h.56V7a1.62,1.62,0,0,1,1,.43,1.6,1.6,0,0,1,.47.93l-1,.13a.78.78,0,0,0-.47-.62V9.37A2.53,2.53,0,0,1,9.53,10a1.55,1.55,0,0,1,.34,1,1.71,1.71,0,0,1-.43,1.19,1.86,1.86,0,0,1-1.19.59v.73H7.69v-.71a1.79,1.79,0,0,1-1.1-.5,2.1,2.1,0,0,1-.54-1.19l1-.11a1.32,1.32,0,0,0,.23.54A1.09,1.09,0,0,0,7.69,11.94Zm0-4.11a.73.73,0,0,0-.37.27.68.68,0,0,0-.14.41.63.63,0,0,0,.13.39.89.89,0,0,0,.38.29ZM8.25,12a.82.82,0,0,0,.48-.27.79.79,0,0,0,.18-.51.68.68,0,0,0-.15-.45.9.9,0,0,0-.51-.29Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack5Solid40);
export default __webpack_public_path__ + "static/media/Symbolpack_5_solid_40.1100906f51a7a779608b6ce7a950f9f1.svg";
export { ForwardRef as ReactComponent };